import React from 'react';
import {Col, Row} from 'react-bootstrap';

import {EmptyMessageDisplay} from "../EmptyMessageDisplay";
import {ArrayUtils, ObjectUtils} from "../../../Utils";

import {ActivityFeedEventRenderFactory} from "./ActivityFeedEventRenderFactory";
import {ActivityFeedItem} from './ActivityFeedItem'
import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";

export function ActivityFeed(props) {
    const {EventIdLogic, EventTypes, EventTypeFilter, ClearFilters, HasMoreEvents} = props;

    const getFilteredEvents = () => {
        const {Events, EventTypeFilter} = props;

        if (Events == null) {
            return Events;
        }

        let events = ObjectUtils.Clone(Events);
        
        if (EventTypeFilter) {
            events = events.filter((x) =>
                EventTypeFilter.ActivityFeedFilterConditions.some(y =>
                        y.ActivityType.activityTypeId == x.Activity.activityTypeId && (
                            y.jsonKey != "" ?
                                (x.Activity.data[y.jsonKey] == y.jsonValue) :
                                true
                        )
                )
            );
        }
        
        return ArrayUtils.GroupBy(
            events,
            x => DateUtils.FormatToLocalDate(x.created, 'MMMM yyyy'),
            (a, b) => DateUtils.ParseUTCDateTime(a.groupOrigin.created) < DateUtils.ParseUTCDateTime(b.groupOrigin.created)
        );
    };

    const onLoadMore = () => {
        const {OnLoadMore} = props;
        OnLoadMore?.();
    };

    const events = getFilteredEvents();

    if (events == null) {
        return <div className="sb-no-items-warning">
            Loading...
        </div>
    }

    if(events.length === 0 && HasMoreEvents) {
        setTimeout(() => {
            onLoadMore();
        }, 100);

        return <div className="sb-no-items-warning">
            Loading...
        </div>
    }

    return <Row className="sb-activity-feed">
        <Col xs={12}>
            {
                events.length === 0 ?
                    <EmptyMessageDisplay
                        ItemName={"activities"}
                        HasFilters={EventTypeFilter !== null}
                        ClearFilters={ClearFilters}
                    /> :
                    null
            }
            {
                events.map(x =>
                    <div key={x.key} className="sb-activity-feed-group">
                        <h3 className="sb-activity-feed-group-header">
                            {x.key}
                        </h3>
                        {
                            x.value.map(y => {
                                const eventContext = ActivityFeedEventRenderFactory.getContextForActivity(EventTypes, y);

                                if (eventContext.valid) {
                                    return <ActivityFeedItem
                                        key={EventIdLogic(y)}
                                        Event={y}
                                        EventIdLogic={EventIdLogic}
                                        title={eventContext.title}
                                        description={eventContext.description}
                                        secondaryDescription={eventContext.secondaryDescription}
                                    />
                                } else {
                                    return null;
                                }
                            })
                        }
                    </div>
                )
            }
        </Col>
        {
            events.length !== 0 ?
                (
                    HasMoreEvents ?
                        <Col xs={12}>
                            <div className="sb-activity-feed-load-more" onClick={onLoadMore}>
                                Load More
                            </div>
                        </Col> :
                        <Col xs={12}>
                            <div className="sb-activity-feed-cant-load-more">
                                You've reach the end of this activity feed.
                            </div>
                        </Col>
                ) :
                null
        }
    </Row>;
}


